import { useMediaQuery } from "@material-ui/core";
import React from "react";

function WrapMobile({ children }) {
  const matches = useMediaQuery("(max-width:600px)");

  return (
    <div
      style={{
        width: matches ? "auto" : "400px",
        margin: "auto",
      }}
    >
      {children}
    </div>
  );
}

export default WrapMobile;
